import { ScoreStatusEnum } from 'lms/types/instructor';
import { ReaccreditationStatus } from './search';

export enum ContentType {
  COURSE = 'COURSE',
  LEARNING_PATH = 'LEARNING_PATH',
  LEARNING_PATH_COMPOSITE = 'LEARNING_PATH_COMPOSITE',
}

export type RecentActivityCard = {
  id: string;
  img: string;
  title: string;
  module: string;
  progress: number;
  index?: number;
};

export type NextCourseResponse = {
  client_id: string;
  course_name: string;
  description: string;
  id: string;
  lp_id?: string;
  lp_name?: string;
  start_date: string;
  user_id: string;
};

export type NextCourseCard = {
  lpId?: string;
  lpName?: string;
  id: string;
  name: string;
  description?: string;
  startDate: string;
};

export type WeekStreak = {
  weekIndex: number; // 1-5
  hasActivity: boolean;
};

export type MonthStreak = {
  monthIndex: number; // 1–12
  weeks: WeekStreak[];
};

export type YearlyStreakResponse = {
  year: number;
  monthlyStreak: MonthStreak[];
};

export type StreaksData = {
  [year: number]: MonthStreak[];
};

export enum RouteType {
  LEARNING_PATH = 'LEARNING_PATH',
  LEARNING_PATH_COMPOSITE = 'LEARNING_PATH_COMPOSITE',
}

export enum RouteResourceType {
  COURSE = 'COURSE',
  LP_GROUP = 'LP_GROUP',
}

export type RouteCard = {
  routeType: RouteType;
  id: string;
  lpcId?: string;
  img: string;
  name: string;
  description?: string;
  progress: number;
  endDate?: string;
  approved: boolean;
  completedAt?: string;
  resources: {
    id: string;
    name: string;
    resource_type: RouteResourceType;
    can_enroll?: boolean;
  }[];
  nextResource?: string;
};

export type CourseCard = {
  id: string;
  img: string;
  name: string;
  title?: string;
  ownerSubdomain: string;
  ownerName: string;
  ownerImg: string;
  description?: string;
  progress?: number;
  approveDate?: string;
  hasReaccreditation?: boolean;
  reaccreditationStatus?: ReaccreditationStatus;
  hasQualtrics?: boolean;
  score?: number;
  isEnabledDc3?: boolean;
  isEnabledDc3InCourse?: boolean;
  dateToShowDC3?: string | null;
  canEnroll?: boolean;
  approved?: boolean;
  module?: string;
  index?: number;
  qualificationStatus?: ScoreStatusEnum;
};

export type CourseMetadata = {
  certificate: string;
  client_id: string;
  courseDuration: number;
  id: string;
  isFromLibrary: boolean;
  isLapzo: boolean;
  modulesCount: number;
};

export enum CertificateMetadataType {
  COURSE = 'COURSE',
  LP = 'LP',
  LPC = 'LPC',
}

export enum DashboardSections {
  COURSES = 'COURSES_IN_PROGRESS',
  ROUTES = 'ROUTES', // LPS and LPCS
  LPS = 'LPS',
  LPCS = 'LPCS',
  PIDS = 'PIDS',
  FINISHED_COURSES = 'FINISHED_COURSES',
  FINISHED_ROUTES = 'FINISHED_ROUTES',
  STREAKS = 'STREAKS',
  NEXT_COURSES = 'NEXT_COURSES', // Scheduled courses
}

export type DashboardLayout = {
  topSection: DashboardSections | null;
  sideSections: DashboardSections[];
  mainSections: DashboardSections[];
}